import {
  IonButton,
  IonChip,
  IonContent,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonModal,
  IonPopover,
  IonText,
} from "@ionic/react";
import { swapVerticalOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSort } from "../../../store/documentsSignerList";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";
import { selectSortButton } from "../../../store/documentsSignerList/selectors/selectSortButton";
import { selectSortDocuments } from "../../../store/documentsSignerList/selectors/selectSortDocuments";

export const SortSelector: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const sortOptions = useSelector(selectSortDocuments);
  const sortButton = useSelector(selectSortButton);
  const dispatch = useDispatch();

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });
  const handleSetSort = (value: string) => {
    dispatch(setSort(value));
    dispatch(fetchDocuments());
    // setShowPopover({ showPopover: false, event: undefined });
    setShowModal(false);
  };
  return (
    <>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        <IonContent>
          <IonItemDivider>Ordenar por</IonItemDivider>
          {sortButton.map(({ option, value }, index) => (
            <IonItem key={index} button onClick={() => handleSetSort(value)}>
              {option}
            </IonItem>
          ))}
        </IonContent>
      </IonModal>
      {/* <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <IonContent>
          <IonItemDivider>Ordenar por</IonItemDivider>
          {sortButton.map(({ option, value }, index) => (
            <IonItem key={index} button onClick={() => handleSetSort(value)}>
              {option}
            </IonItem>
          ))}
        </IonContent>
      </IonPopover> */}
      <IonChip
        class="ion-margin-horizontal"
        color="medium"
        outline
        onClick={(e: any) => {
          // e.persist();
          // setShowPopover({ showPopover: true, event: e });
          setShowModal(true);
        }}
      >
        <IonLabel>
          <IonIcon icon={swapVerticalOutline} slot="start" />
        </IonLabel>
      </IonChip>
    </>
  );
};
